import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ProductSetsListItem } from "../../productsSets.types";
import { requestProductSets } from "./productSets.request";

const useProductSets = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<ProductSetsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const queryClient = useQueryClient();
  const queryKey = ["product-sets", "all", requestParams];

  const { data, ...rest } = useQuery({
    queryKey: ["product-sets", "all", requestParams],
    queryFn: async () => await requestProductSets(requestParams),
    ...options
  });

  const setProductSets = (newBanners: ProductSetsListItem[]) => {
    queryClient.setQueriesData(queryKey, {
      data: newBanners,
      meta: data?.meta
    });
  };

  return {
    productSets: data?.data ?? [],
    meta: data?.meta,
    setProductSets,
    ...rest
  };
};

export default useProductSets;
